(function ($, Drupal) {
  'use strict';
  Drupal.behaviors.discoverparks = {
    already_run: false,
    // Run on load
    attach: function (context, settings) {

      // Only ever run this once on page load (otherwise there's a quirk that reruns it)
      if (this.already_run === true) {
        return;
      }
      this.already_run = true;

      window.addEventListener('resize', this.windowResize);

      // Init Adword Tracking
      adwordsTracking.init();

      // Init Druapl pretty messages
      niceMessages.init();

      // Init navigation scripts
      navigationHandler.init();

      // Init properties scripts
      properties.init();

      // Init paragraphs scripts
      paragraphs.init();

      // Init enquire scripts
      enquire.init();

      // Newsletter
      newsletter.init();

      // Setup infinite scroll behaviour
      Drupal.behaviors.discoverparksInfinity.activate();

    },
    // Action to run on window resize
    windowResize: function () {
      // Resize actions go here
      paragraphs.onResize();
    }

  };

  var adwordsTracking = {
    init: function () {
      // This is trying to provide better google analytics tracking for all park websites
      // Ads are targeted towards the main Discover Parks website but we lose tracking abilities when they click into one of the subsites.
      // example URL -> utm_source=google&utm_medium=cpc&utm_campaign=2038549128&ad_group=72714553835&keyword=country%20park%20homes&gclid=EAIaIQobChMIgfDwgcTA4wIVyLTtCh2cjwjaEAMYAyAAEgJ-wfD_BwE
      if (window.location.search.indexOf('utm_source') !== -1 && window.location.search.indexOf('utm_campaign') !== -1 || window.location.search.indexOf('ad_group') !== -1) {
        setCookie('adwordsTracking', window.location.search);
      }

      var domains = [
        'discoverparks.co.uk',
        'www.discoverparks.co.uk',
        'arrowbank.co.uk',
        'www.arrowbank.co.uk',
        'rockbridgepark.co.uk',
        'www.rockbridgepark.co.uk',
        'pearllake.co.uk',
        'www.pearllake.co.uk'
      ];

      if (!$('body').hasClass('user-logged-in')) {
        if (getCookie('adwordsTracking')) {
          $('a').each(function () {
            var _this = $(this);
            var _href = $(this)[0].href;

            // No fragment URLs please
            if (_href.indexOf('/') === -1) {
              return;
            }

            var url = new URL(_href);

            if (domains.indexOf(url.hostname) !== -1 && url.hostname !== window.location.hostname) {
              _this.attr('href', _href + getCookie('adwordsTracking'));
            }
          });
        }
      }

    }
  }

  var newsletter = {
    init: function () {
      this.autocomplete();
    },
    autocomplete: function () {
      var $originalFormAction = $('#mc-embedded-subscribe-form').attr('action');
      $("#mce-EMAIL").keyup(function () {
        var $value = $(this).val();
        $('#mc-embedded-subscribe-form').attr('action', $originalFormAction + '&MERGE0=' + $value);
      }).keyup();
    }
  }

  var properties = {
    init: function () {
      this.homesCarousel();
      this.otherParksCarousel();
    },
    homesCarousel: function () {
      if ($('.view-display-id-properties_for_sale').length) {

        var $centerPadding = $('.view-properties').hasClass('slide-count-1') ? false : true;

        $('.view-display-id-properties_for_sale .view-content').slick({
          dots: true,
          appendDots: '.slick-list',
          customPaging: function (slider, i) {
            return '<a><span>' + (i + 1) + '</span></a>';
          },
          infinite: true,
          slidesToShow: 1,
          centerMode: true,
          centerPadding: ($centerPadding) ? '270px' : '0px',
          appendArrows: '.slick-list',
          prevArrow: '<button type="button" class="slick-prev"><i></i><span>Previous</span></button>',
          nextArrow: '<button type="button" class="slick-next"><i></i><span>Next</span></button>',
          lazyLoad: 'ondemand',
          responsive: [{
            breakpoint: 1140,
            settings: {
              centerPadding: ($centerPadding) ? '220px' : '0px',
            }
          }, {
            breakpoint: 920,
            settings: {
              centerPadding: ($centerPadding) ? '170px' : '0px',
            }
          }, {
            breakpoint: 740,
            settings: {
              centerPadding: ($centerPadding) ? '100px' : '0px',
            }
          }, {
            breakpoint: 500,
            settings: {
              centerPadding: ($centerPadding) ? '50px' : '0px',
            }
          }]
        });

        // var bLazy = new Blazy({
        //   container: '.view-display-id-properties_for_sale .view-content'
        // });

        // $('.view-display-id-properties_for_sale .view-content').on('afterChange', function(event, slick, direction){
        //   bLazy.revalidate();
        // });
      }
    },
    otherParksCarousel: function () {
      if ($('.view-display-id-other_parks_homes_for_sale .views-row, .view-display-id-other_homes_for_sale .views-row, .view-display-id-other_residential_parks_homes_for_sale .views-row').length) {
        var $slidesToNavigate = 3;
        var $slider = '.view-display-id-other_parks_homes_for_sale .view-content, .view-display-id-other_homes_for_sale .view-content, .view-display-id-other_residential_parks_homes_for_sale .view-content';

        $($slider).slick({
          dots: true,
          infinite: false,
          slidesToShow: $slidesToNavigate,
          slidesToScroll: $slidesToNavigate,
          appendArrows: '.slick-list',
          prevArrow: '<button type="button" class="slick-prev"><i></i><span>Previous</span></button>',
          nextArrow: '<button type="button" class="slick-next"><i></i><span>Next</span></button>',
          responsive: [{
            breakpoint: 1080,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 2,
            }
          }, {
            breakpoint: 900,
            settings: {
              slidesToShow: 3,
              slidesToScroll: 3,
            }
          }, {
            breakpoint: 700,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 2,
            }
          }, {
            breakpoint: 400,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1,
            }
          }]
        });

        window.addEventListener("load", function() {
          setTimeout(function(){
            $($slider).slick("refresh");},
          1000);
       });

      }
    }
  }

  var navigationHandler = {
    mobileNavTrigger: '.hamburger',
    siteHeader: 'header.site-header',
    init: function (context) {
      this.mobileOverlay(context);
      this.stickyHeader(context);
      this.mobileOverlaySubMenus(context);
      // this.stickySidebar(context);
    },
    mobileOverlay: function (context) {
      var scrollTo;
      var prevScrolPos;
      $(this.mobileNavTrigger, context).on('click', function () {
        if (!$('body').hasClass('mobile-nav-active')) {
          prevScrolPos = $(window).scrollTop();
          scrollTo = 0;
        } else {
          scrollTo = prevScrolPos;
        }
        $('body').toggleClass('mobile-nav-active') && $('html,body').scrollTop(scrollTo);
      });
    },
    stickySidebar: function (context) {
      $(".sidebar-first").stick_in_parent();
    },
    stickyHeader: function (context) {
      var $siteHeaderOffset = $(this.siteHeader, context).offset().top;
      var $siteHeaderHeight = $(this.siteHeader, context).outerHeight();
      var $activeClass = 'sticky-menu-active';
      var $customOffset = 40;

      $(window).on('scroll', function () {
        if ($(window).scrollTop() > ($siteHeaderOffset + $siteHeaderHeight + $customOffset)) {
          $('body').addClass($activeClass);
        } else {
          $('body').removeClass($activeClass);
        }
      });
    },
    mobileOverlaySubMenus: function (context) {
      var $toplink = $('.region-mobile-overlay-content nav.navigation ul.menu:first > li > .arrow', context);
      $toplink.on('click', function (e) {
        e.preventDefault();
        $(this).parent().toggleClass('toggled-active');
        $(this).toggleClass('toggled-active');
      });
    }
  }

  var paragraphs = {
    parkFeatures: '.field--name-field-park-features',
    parkFeaturesNav: '.park-features--nav',
    init: function (context) {
      this.imageTextOverlay();
      this.parkfeatures();

      $('a.lightbox').swipebox({
        hideBarsDelay: 0
      });

      this.imageCarousel();
    },
    onResize: function () {
      this.imageTextOverlay();
    },
    imageTextOverlay: function () {
      var win_width = $(window).width();
      var spacing = 100;

      $('.paragraph--type--image-text-overlay').each(function () {
        var text_height = $('.text-wrapper', this).outerHeight();
        $(this).css('height', text_height + spacing + 'px');
      });
    },
    imageCarousel: function () {
      $('.paragraph--type--image-carousel .slick-carousel').slick({
        infinite: true,
        slidesToShow: 3,
        slidesToScroll: 3,
        arrows: false,
        dots: true,
        responsive: [{
            breakpoint: 600,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 2
            }
          },
          {
            breakpoint: 480,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1
            }
          }
        ]
      });
    },
    parkfeatures: function () {
      if ($('.field--name-field-park-features:not(.domain-discover_parks)')) {
        // Setup initial classes
        $(this.parkFeatures + ' li[data-slide="1"]').addClass('active');
        $(this.parkFeatures + ' a[data-index="1"]').addClass('active');
        // Update nav appearance + content switching
        $(this.parkFeaturesNav + ' a').on('click', function (e) {
          e.preventDefault();
          $("ul").find('li[data-slide], a[data-index]').removeClass('active')
          $("ul").find('li[data-slide="' + $(this).data('index') + '"], a[data-index="' + $(this).data('index') + '"]').addClass('active');
        });
      }
    }
  };

  //Enquire page
  var enquire = {
    init: function () {
      // Check if hidden field exists
      if ($('#enquire-parks-data').length < 1) return;
      this.initParksIcons();
    },
    initParksIcons: function () {
      var parkIcon = $('.our-parks__icon');
      var json = JSON.parse($('#enquire-parks-data').val());

      for (var i = 0; i < parkIcon.length; i++) {
        var jsonData = null;

        for (var y = 0; y < json.length; y++) {
          if (json[y].domain === parkIcon[i].dataset.park) {
            jsonData = json[y];
            jsonData.name = parkIcon[i].dataset.name;
            break;
          }
        }

        var email = "";
        var tel = "";
        var add = "";

        if (typeof jsonData.email !== "undefined") email = jsonData.email;
        if (typeof jsonData.telephone !== "undefined") tel = jsonData.telephone;
        if (typeof jsonData.address !== "undefined") add = "<span class=\"popup-text__detail\">" + jsonData.address + "</span>\n";

        $(parkIcon[i]).append(
          "<div class=\"our-parks__popup\" data-domain=\"" + jsonData.domain + "\">\n" +
          "    <div class=\"popup-text\">\n" +
          "      <span class=\"popup-text__detail popup-text__detail--title\">" + jsonData.name + "</span>\n" +
          (add) +
          '<span class=\"popup-text__detail\"><a href="mailto:' + (email) + '" target="_blank">' + (email) + '</a></span>' +
          '<span class=\"popup-text__detail\"><a href="tel:' + (tel) + '" target="_blank">' + (tel) + '</a></span>' +
          "   </div>\n" +
          "</div>"
        )
      }

      var activeClass = "our-parks__popup--active";

      parkIcon.on('click', function () {
        var popup = $(this);
        //  for (var i = 0; i < parkIcon.length; i++) {
        // if (parkIcon[i].dataset.park === popup[0].dataset.domain.trim()) continue;
        //    $(parkIcon[i]).children().eq(1).removeClass(activeClass);
        //  }

        parkIcon.removeClass(activeClass);

        if (popup.hasClass(activeClass)) {
          popup.removeClass(activeClass);
          return;
        }

        popup.toggleClass(activeClass);
      });


      $(document).mouseup(function (e) {
        var container = $(".our-parks");

        // if the target of the click isn't the container nor a descendant of the container
        if (!container.is(e.target) && container.has(e.target).length === 0) {
          parkIcon.removeClass(activeClass);
        }

      });

    }
  }


  // Nicer Drupal messages using Sweet Alert 2
  var niceMessages = {
    init: function () {
      var messages = [];

      var originalMessages = document.getElementsByClassName("status-messages");
      for (var i = 0; i < originalMessages.length; i++) {

        // Get the title and message
        var matches, title, message = null;
        matches = originalMessages.item(i).querySelectorAll('h2');
        if (matches.length > 0) {
          title = matches[0];
        }
        matches = originalMessages.item(i).querySelectorAll('div');
        if (matches.length > 0) {
          message = matches[0];
        }

        // Don't do this for really long messages. They're probably dev. errors that we want to read.
        if (message === null || message.innerText.length > 300) {
          continue;
        }

        // Hide the original element
        originalMessages.item(i).style.display = 'none';

        // What kind of alert is it?
        var type = 'info';
        if (message.classList.contains('status')) {
          type = 'success';
        } else if (message.classList.contains('warning')) {
          type = 'warning';
        } else if (message.classList.contains('error')) {
          type = 'error';
        }

        // Add to the queue
        var tags = /<\/?([a-z][a-z0-9]*)\b[^>]*>/gi;
        var comments = /<!--[\s\S]*?-->/gi;
        messages.push({
          'title': title !== null ? title.innerHTML.replace(comments, '').replace(tags, '') : '',
          'text': message.innerHTML.replace(comments, '').replace(tags, ''),
          'type': type
        });
      }
      if (messages.length) {
        swal.queue(messages)
      }
    }
  }

  function setCookie(name, value, days) {
    var expires = "";
    if (days) {
      var date = new Date();
      date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
      expires = "; expires=" + date.toUTCString();
    }
    document.cookie = name + "=" + (value || "") + expires + "; path=/";
  }

  function getCookie(name) {
    var nameEQ = name + "=";
    var ca = document.cookie.split(';');
    for (var i = 0; i < ca.length; i++) {
      var c = ca[i];
      while (c.charAt(0) == ' ') c = c.substring(1, c.length);
      if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
    }
    return null;
  }

  function eraseCookie(name) {
    document.cookie = name + '=; Max-Age=-99999999;';
  }

})(jQuery, Drupal);
